import { projects } from '../data/projectsData';
import Projects from './Projects';

function FeaturedProjects() {
    const firstThreeProjects = projects.slice(0, 3);

    return (
        <div id="projects" className="max-w-screen-2xl h-fit mx-auto my-auto scroll-mt-36">
            <div className="w-11/12 mx-auto flex flex-col justify-center items-center gap-4">
				<h2 className="text-2xl xs:text-3xl sm:text-5xl font-bold">Featured Projects</h2>
				<p className="font-medium text-center">
					Some of my recent work and the solutions I have built.
				</p>
			</div>
            <Projects projects={firstThreeProjects} root={'root'} />
        </div>
    );
}

export default FeaturedProjects;